import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { applyPolyfills, defineCustomElements } from 'scrd-components-base-ui/loader';
import App from './App'





const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

applyPolyfills().then(() => {
  defineCustomElements();
});
